import styled from "styled-components";

const Root = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;

	/* !important: LightInputModal задаёт детям свои размеры, а содержимое должно
	   ужиматься в её max-height, чтобы прокручивался только список причин. */
	flex: 1 1 auto !important;
	min-width: 370px;
	min-height: 0 !important;

	padding-inline: 24px;
`;

export default Root;
